module.exports = __webpack_public_path__ + "static/media/WITH FLAPS X3.60eef6a6.svg";